import type { Tool } from './types';
import type { Locale } from '@/lib/i18n';
import { getToolTranslations } from './i18n';
import type { ToolSlug } from './i18n';
import { freeKundli } from './free-kundli';
import { kundliMatching } from './kundli-matching';
import { mangalDoshaCalculator } from './mangal-dosha-calculator';
import { aiAstrologer } from './ai-astrologer';
import { nakshatraCalculator } from './nakshatra-calculator';
import { dashaCalculator } from './dasha-calculator';
import { lagnaCalculator } from './lagna-calculator';

export type { Tool } from './types';

/** All tool landing pages, in nav/sitemap order. */
export const tools: Tool[] = [
  aiAstrologer,
  freeKundli,
  kundliMatching,
  mangalDoshaCalculator,
  nakshatraCalculator,
  dashaCalculator,
  lagnaCalculator,
];

export function getToolBySlug(slug: string, locale: Locale = 'en'): Tool | null {
  const tool = tools.find((t) => t.slug === slug) ?? null;
  if (!tool || locale === 'en') return tool;
  // Language over configuration: slug, calculator, hrefs and appName stay; every
  // string the visitor reads comes from the locale's translation table.
  const text = getToolTranslations(locale)?.[slug as ToolSlug];
  if (!text) return tool;
  const { relatedLabels, ...rest } = text;
  return { ...tool, ...rest, related: tool.related.map((r, i) => ({ ...r, label: relatedLabels[i] ?? r.label })) };
}

export function getAllTools(locale: Locale): Tool[];
export function getAllTools(): Tool[];
export function getAllTools(locale: Locale = 'en'): Tool[] {
  return locale === 'en' ? tools : tools.map((t) => getToolBySlug(t.slug, locale)!);
}

export const TOOL_SLUGS: string[] = tools.map((t) => t.slug);
